import React from "react";

import { ReactComponent as ModalIcon } from "../../../assets/svg/actionlist_modal_icon.svg";
import { ReactComponent as ArrowRightIcon } from "../../../assets/svg/keyboard_arrow_right.svg";
import { INewAnswer } from "../../../state";
import { Context } from "../../../studentStore";
import { STUDENT_SESSION_KEY } from "../../../Definition";

import style from "./ActionSummaryModal.module.scss";

export type ActionSummaryModalProps = {
  onClose: () => void;
  myAnswers: INewAnswer[] | [];
};

const ActionSummaryModal: React.FC<ActionSummaryModalProps> = ({
  onClose,
  myAnswers,
}) => {
  const answerContents = (myAnswers as INewAnswer[]).flatMap(a => a.contents);
  const LEARNING_INDEX = 0;
  const ACTION_INDEX = 1;
  const { state } = React.useContext(Context);
  const isG4sEnabled = !!state.student?.g4s_enabled || state.g4s_basic_enabled;

  const extra = sessionStorage.getItem(STUDENT_SESSION_KEY)
    ? `?session_id=${sessionStorage.getItem(STUDENT_SESSION_KEY)}`
    : "";

  // lesson3のまとめワークでは振り返りの回答が表示できないため回答の表示非表示の制限を入れるため必要
  const isWork3IssueWithAnswers = React.useMemo(() => {
    const work3Issue = state.lesson?.issues?.find(issue => issue.to_gear);
    if (!work3Issue) {
      return false;
    }
    const hasWork3Answer = (myAnswers as INewAnswer[]).some(
      answer => answer.issue_id === work3Issue.id,
    );

    return hasWork3Answer;
  }, [state.lesson, myAnswers]);

  return (
    <div className={style.actionSummaryModal}>
      <div
        className={style.actionSummaryModal__backDrop}
        onClick={() => onClose()}
      />
      <div className={style.actionSummaryModal__content}>
        <ModalIcon />
        <div className={style.headerContainer}>
          <p className={style.title}>学んだことを授業外で実践しましょう。</p>
          {isG4sEnabled && (
            <div className={style.descriptionContainer}>
              <p className={style.title}>
                振り返りWORKは自動でGEARにストックされています。
              </p>
              <p className={style.description}>
                ※GEARは左側のメニューから開くことができます。
              </p>
            </div>
          )}
        </div>
        {isWork3IssueWithAnswers && (
          <div className={style.answerContainer}>
            <p className={style.title}>あなたの回答</p>
            <div className={style.answerBoxContainer}>
              <div className={style.answerBox}>
                <p className={style.title}>学びや気づき</p>
                <p className={style.description}>
                  {answerContents[LEARNING_INDEX]?.content}
                </p>
              </div>
              <ArrowRightIcon />
              <div className={style.answerBox}>
                <p className={style.title}>行動宣言</p>
                <p className={style.description}>
                  {answerContents[ACTION_INDEX]?.content}
                </p>
              </div>
            </div>
          </div>
        )}
        <div className={style.buttonContainer}>
          <button className={style.close} onClick={() => onClose()}>
            閉じる
          </button>
          {isG4sEnabled && !state.isMasqueradeByTeacher && (
            <button
              className={style.submit}
              onClick={() => {
                window.open(
                  `${process.env.REACT_APP_STUDENT_GEAR_URL}/student/boxes/${state.gearbox_id}${extra}`,
                  "_blank",
                );
              }}
            >
              みんなの行動宣言を見る
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
export default ActionSummaryModal;
